import { FloatingMediaEditButton } from './FloatingMediaEditButton';
import { FloatingMediaUrlInput } from './FloatingMediaUrlInput';

export const FloatingMedia = {
  EditButton: FloatingMediaEditButton,
  UrlInput: FloatingMediaUrlInput,
};
